import CommonIFrame from '../atoms/CommonIFrame';

const Planner = () => {
    return <CommonIFrame src="https://preview--pure-plain-start.lovable.app/" title="Planner" />;
};

export default Planner;
